// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.main-div {
  margin-left: 12.25%;
  margin-right: 12.25%;
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  .main-div {
    margin-left: 5.25%;
    margin-right: 5.25%;
  }
}

.review-heading {
  font-size: 32px;
  color: #000000;
  opacity: 1;
  float: left;
  margin-bottom: 0px;
}
@media (max-width: 1024px) {
  .review-heading {
    line-height: 30px;
  }
}

.review-subheading {
  margin-top: 20px;
  margin-bottom: 5px;
}

.inline-success {
  display: inline-block;
  margin-right: 10px;
}
@media (max-width: 1024px) {
  .inline-success {
    display: table-cell;
    margin-right: 15px;
  }
}

.success-message {
  font-size: 24px;
  color: #067a3e;
  opacity: 1;
  margin-bottom: 10px;
}

@media (min-width: 1025px) {
  .success-img {
    margin-top: -20px;
  }
}

.success-description {
  margin-top: -6px;
  margin-bottom: 0px;
}

.success-section {
  margin-bottom: 20px;
  width: 100%;
}

.review-info {
  width: 100%;
  float: left;
  margin-top: 2%;
  margin-bottom: 2%;
}

.review-blocks {
  display: inline-block;
  margin-right: 10%;
}

.review-block-heading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.review-block-value {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.contact-heading {
  margin-top: 2%;
  margin-bottom: 2%;
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.contact-section {
  width: 100%;
}

.added-links {
  display: inline-block;
  width: 40%;
}

.phone-field, .email-field, .city-field, .state-field, .zip-field, .time-field {
  margin-bottom: 10px;
}

.contact-fields {
  margin-bottom: 10px;
}

.ctn-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-section, .ctn-section {
  margin-top: 2%;
}

.acknowledgement-sub-section {
  display: flexbox;
  background-color: #f2f2f2;
}

.acknowledgement-section {
  background-color: transparent;
}

.acknowledgement-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  padding: 15px 15px 15px 15px;
  margin-bottom: 0px;
}

.acknowledgement-description {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  padding: 5px 15px 5px 15px;
  margin-bottom: 0px;
}

.confirm-section {
  padding: 15px 15px 15px 15px;
}

#requestEnrollment {
  float: right;
  font-size: 17px;
}

.review-subheading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  float: left;
}

a {
  color: #1483d9;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

#cancel-link {
  float: right;
  margin-right: 20px;
  margin-top: 15px;
  font-size: 18px;
}

.submit-section {
  height: 50px;
}

.labels-inline {
  display: inline-block;
}

.bold-heading {
  font-weight: 600;
}

.offer-heading {
  font-size: 16px;
  margin-bottom: 10px;
}

.bullet-points {
  list-style: disc;
}

ul {
  padding-left: 20px;
}

.review-section {
  padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-fiveg/confirm/confirm.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,UAAA;EACA,gBAAA;AAoJJ;;AAlJA;EACI,mBAAA;EACA,oBAAA;EACA,mBAAA;AAqJJ;AApJI;EAJJ;IAKQ,kBAAA;IACA,mBAAA;EAuJN;AACF;;AArJA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAwJJ;AAvJI;EANJ;IAOQ,iBAAA;EA0JN;AACF;;AAxJA;EACI,gBAAA;EACA,kBAAA;AA2JJ;;AAzJA;EACI,qBAAA;EACA,kBAAA;AA4JJ;AA3JI;EAHJ;IAIQ,mBAAA;IACA,kBAAA;EA8JN;AACF;;AA5JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AA+JJ;;AA3JI;EADJ;IAEQ,iBAAA;EA+JN;AACF;;AA7JA;EACI,gBAAA;EACA,kBAAA;AAgKJ;;AA7JA;EACI,mBAAA;EACA,WAAA;AAgKJ;;AA9JA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAiKJ;;AA/JA;EACI,qBAAA;EACA,iBAAA;AAkKJ;;AAhKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAmKJ;;AAjKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAoKJ;;AAlKA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAqKJ;;AAnKA;EACI,WAAA;AAsKJ;;AApKA;EACI,qBAAA;EACA,UAAA;AAuKJ;;AArKA;EACI,mBAAA;AAwKJ;;AAtKA;EACI,mBAAA;AAyKJ;;AAvKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA0KJ;;AAxKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA2KJ;;AAzKA;EACI,cAAA;AA4KJ;;AA1KA;EACI,gBAAA;EACA,yBAAA;AA6KJ;;AA3KA;EACI,6BAAA;AA8KJ;;AA5KA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;AA+KJ;;AA7KA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,kBAAA;AAgLJ;;AA9KA;EACI,4BAAA;AAiLJ;;AA/KA;EACI,YAAA;EACA,eAAA;AAkLJ;;AAhLA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AAmLJ;;AAjLA;EACI,cAAA;EACA,eAAA;AAoLJ;;AAlLA;EACI,0BAAA;AAqLJ;;AAnLA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAsLJ;;AApLA;EACI,YAAA;AAuLJ;;AArLA;EACI,qBAAA;AAwLJ;;AArLA;EACI,gBAAA;AAwLJ;;AArLA;EACI,eAAA;EACA,mBAAA;AAwLJ;;AArLA;EACI,gBAAA;AAwLJ;;AArLA;EACI,kBAAA;AAwLJ;;AArLA;EACI,iBAAA;AAwLJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.main-div {\n    margin-left: 12.25%;\n    margin-right: 12.25%;\n    margin-bottom: 20px;\n    @media(max-width: 1024px) {\n        margin-left: 5.25%;\n        margin-right: 5.25%;\n    }\n}\n.review-heading {\n    font-size: 32px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n    margin-bottom: 0px;\n    @media(max-width: 1024px) {\n        line-height: 30px;\n    }\n}\n.review-subheading {\n    margin-top: 20px;\n    margin-bottom: 5px;\n}\n.inline-success {\n    display: inline-block;\n    margin-right: 10px;\n    @media (max-width: 1024px) {\n        display: table-cell;\n        margin-right: 15px;\n    }\n}\n.success-message {\n    font-size: 24px;\n    color: #067a3e;\n    opacity: 1;\n    margin-bottom: 10px;\n\n}\n.success-img {\n    @media (min-width: 1025px) {\n        margin-top: -20px;\n    }\n}\n.success-description {\n    margin-top: -6px;\n    margin-bottom: 0px;\n    // margin-left: 59px;\n}\n.success-section {\n    margin-bottom: 20px;\n    width: 100%;\n}\n.review-info {\n    width: 100%;\n    float: left;\n    margin-top: 2%;\n    margin-bottom: 2%;\n}\n.review-blocks {\n    display: inline-block;\n    margin-right: 10%;\n}\n.review-block-heading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.review-block-value {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.contact-heading {\n    margin-top: 2%;\n    margin-bottom: 2%;\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.contact-section {\n    width: 100%;\n}\n.added-links {\n    display: inline-block;\n    width: 40%;\n}\n.phone-field, .email-field, .city-field, .state-field, .zip-field, .time-field {\n    margin-bottom: 10px;\n}\n.contact-fields {\n    margin-bottom: 10px;\n}\n.ctn-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-section, .ctn-section {\n    margin-top: 2%;\n}\n.acknowledgement-sub-section {\n    display: flexbox;\n    background-color: #f2f2f2;\n}\n.acknowledgement-section {\n    background-color: transparent;\n}\n.acknowledgement-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 0px;\n}\n.acknowledgement-description {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    padding: 5px 15px 5px 15px;\n    margin-bottom: 0px;\n}\n.confirm-section {\n    padding: 15px 15px 15px 15px;\n}\n#requestEnrollment {\n    float: right;\n    font-size: 17px;\n}\n.review-subheading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n}\na {\n    color: #1483d9;\n    cursor: pointer;\n}\na:hover {\n    text-decoration: underline;\n}\n#cancel-link {\n    float: right;\n    margin-right: 20px;\n    margin-top: 15px;\n    font-size: 18px;\n}\n.submit-section {\n    height: 50px;\n}\n.labels-inline {\n    display: inline-block;\n}\n\n.bold-heading {\n    font-weight: 600;\n}\n\n.offer-heading {\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.bullet-points {\n    list-style: disc;\n}\n\nul {\n    padding-left: 20px;\n}\n\n.review-section {\n    padding-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
